import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "App-Bidd-H" }
const _hoisted_2 = { class: "App-Bidd" }
const _hoisted_3 = { class: "App-Bidd-Tal" }
const _hoisted_4 = {
  style: {"line-height":"18px"},
  class: "App-Bidd-T"
}
const _hoisted_5 = {
  key: 0,
  "m-tb-0": "",
  "f-w-700": ""
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  "mute-primary": "",
  style: {"padding-right":"8px"}
}
const _hoisted_8 = { "mute-secondary": "" }
const _hoisted_9 = { class: "App-Bid-Cont" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  "m-tb-0": ""
}
const _hoisted_12 = {
  "m-tb-0": "",
  "f-w-600": ""
}
const _hoisted_13 = {
  key: 0,
  style: {"padding-right":"4px"}
}
const _hoisted_14 = { style: {"display":"inline-block","height":"13px","overflow":"hidden"} }
const _hoisted_15 = { "mute-secondary": "" }
const _hoisted_16 = { "m-t-1": "" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_app_truncate = _resolveComponent("app-truncate")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_BidPayModal = _resolveComponent("BidPayModal")!
  const _directive_blur = _resolveDirective("blur")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createVNode(_component_el_tooltip, { content: "Visit the opportunity" }, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, {
            to: `/opportunities/${_ctx.bidding.opportunity._id}`
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_ctx.bidding.opportunity !== undefined)
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_5, _toDisplayString(_ctx.bidding.opportunity.outcome) + " Opportunity ", 1))
                    : _createCommentVNode("", true),
                  (_ctx.bidding.business)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.bidding.business.name), 1),
                        _createElementVNode("span", _hoisted_8, " Sent " + _toDisplayString(_ctx.$moment(_ctx.bidding.createdAt).fromNow()), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.user.type === 'founder')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_ctx.bidding.talent !== undefined)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_11, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("span", {
                      "f-w-600": "",
                      "mute-secondary": ""
                    }, " Bidding for ", -1)
                  ]))]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_tooltip, { content: "Visit talent's page" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    to: `/talent/${_ctx.bidding.talent._id}/${_ctx.bidding.opportunity._id}`
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h4", _hoisted_12, [
                        (
                    _ctx.bidding.talent.headline || _ctx.bidding.talent.areaOfExpertise
                  )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$filters.capitalize(
                      _ctx.bidding.talent.headline || _ctx.bidding.talent.areaOfExpertise
                    )) + "(er) ", 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", null, [
                          _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_14, [
                            _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(_ctx.bidding.talent.firstName)) + " " + _toDisplayString(_ctx.$filters.capitalize(_ctx.bidding.talent.lastName)), 1)
                          ])), [
                            [_directive_blur, _ctx.bidding.talent]
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_divider, { style: {"margin":"12px 0"} })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createVNode(_component_app_truncate, {
            onViewMore: _cache[0] || (_cache[0] = ($event: any) => (_ctx.max = 20000)),
            max: _ctx.max,
            content: _ctx.bidding.description
          }, null, 8, ["max", "content"]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_space, { size: 12 }, {
              default: _withCtx(() => [
                (_ctx.bidding.compensationTypes.includes('equity'))
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      "tag-default": "",
                      "is-all-borderless": "",
                      round: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$filters.number(_ctx.bidding.equity)) + "% Equity ", 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.bidding.compensationTypes.includes('cash'))
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      "tag-default": "",
                      "is-all-borderless": "",
                      round: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(_ctx.bidding.currency)) + " " + _toDisplayString(_ctx.$filters.number(_ctx.bidding.cash)), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_15, " Expiration " + _toDisplayString(_ctx.$moment(_ctx.bidding.expireAt).fromNow()), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_el_row, {
            align: "middle",
            justify: "space-between",
            "w-100": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_el_space, { size: 12 }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      (_ctx.isExpired && _ctx.bidding.status === 'ongoing')
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 0,
                            type: "danger",
                            round: "",
                            size: "mini",
                            "is-all-borderless": "",
                            "f-w-600": ""
                          }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createTextVNode(" Expired ", -1)
                            ]))]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            type: 
                      _ctx.bidding.status === 'ongoing'
                        ? 'warning'
                        : _ctx.bidding.status === 'accepted'
                        ? 'success'
                        : 'danger'
                    ,
                            round: "",
                            size: "mini",
                            "is-all-borderless": "",
                            "f-w-600": ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(_ctx.bidding.status)), 1)
                            ]),
                            _: 1
                          }, 8, ["type"]))
                    ]),
                    false
                      ? (_openBlock(), _createBlock(_component_el_link, {
                          key: 0,
                          size: "mini",
                          dark: ""
                        }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("Feedback", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              (!_ctx.isExpired)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (_ctx.bidding.status === 'ongoing')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                          (_ctx.user.type == 'talent')
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                size: "mini",
                                "is-borderless": "",
                                type: "danger",
                                round: "",
                                plain: "",
                                icon: "el-icon-close",
                                onClick: _ctx.rejectBid
                              }, {
                                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                  _createTextVNode(" Reject ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          (_ctx.user.type == 'talent')
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 1,
                                onClick: _ctx.acceptBid,
                                size: "mini",
                                "is-borderless": "",
                                type: "success",
                                round: "",
                                plain: "",
                                icon: "el-icon-check"
                              }, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                  _createTextVNode(" Accept ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (
                  _ctx.user.type === 'founder' &&
                  _ctx.bidding.talent.isPaid !== true &&
                  _ctx.isAccepted
                )
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          onClick: _ctx.openPayModal,
                          loading: _ctx.loadingPay,
                          "is-borderless": "",
                          type: "primary",
                          round: "",
                          size: "mini",
                          icon: "el-icon-cancel"
                        }, {
                          default: _withCtx(() => [
                            _cache[6] || (_cache[6] = _createTextVNode(" Pay ", -1)),
                            (_ctx.talentPrice !== undefined)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.talentPrice.symbol) + " " + _toDisplayString(_ctx.$filters.number(_ctx.talentPrice.amount)), 1))
                              : _createCommentVNode("", true),
                            _cache[7] || (_cache[7] = _createElementVNode("span", null, " to reveal full details ", -1))
                          ]),
                          _: 1
                        }, 8, ["onClick", "loading"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      (_ctx.user.type === 'founder' && _ctx.talentPrice !== undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createVNode(_component_BidPayModal, {
              talentPrice: _ctx.talentPrice,
              onClose: _ctx.hidePayModal,
              isOpen: _ctx.payingModelOpen,
              talent: _ctx.bidding.talent,
              opportunity: _ctx.bidding.opportunity,
              bidding: _ctx.bidding
            }, null, 8, ["talentPrice", "onClose", "isOpen", "talent", "opportunity", "bidding"])
          ]))
        : _createCommentVNode("", true)
    ])), [
      [_directive_loading, _ctx.loading]
    ])
  ]))
}